import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios';


import './plugins/vuetify'
import App from './App.vue'


import { routes } from './routes';
Vue.use(VueRouter);

const router = new VueRouter({
	routes: routes,
	
	//mode: 'hash',		// default mode using the hashtag in the route (/#/)
	//mode: 'history',	// history mode without using the hashtag (server should always return the index.html on 404)
});

Vue.config.productionTip = false

export const eventBus = new Vue({
	methods: {
		setLastRedemption(redemption) {
			this.$emit('setLastRedemption', redemption);
		}
	}
});

new Vue({
	render: h => h(App),
	router: router,
}).$mount('#app')
